// src/config/general.js
// Configuraciones generales de la aplicación
import noImageAvailable from '../assets/no-image-available.jpg'

export const LOCALSTORAGE_KEY = 'tintin-admin'
export const API_URL = process.env.REACT_APP_API_URL
export const API_UPLOADS_URL = process.env.REACT_APP_API_URL + 'uploads/'
export const DEFAULT_FETCH_CUANTOS = 10
export const DEFAULT_IMAGE = noImageAvailable
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCaw8ahy7ztFKt6aq9kbqVlM1Bk_YmUU9s'